import { render, staticRenderFns } from "./float-bottom.vue?vue&type=template&id=1b890da4&scoped=true"
import script from "./float-bottom.vue?vue&type=script&lang=js"
export * from "./float-bottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b890da4",
  null
  
)

export default component.exports